import {
    LOGIN,
    LOGOUT,
    GET_USER,
    UPDATE_VISIT,
    REGISTER,
    PAYMENT_SUCCESSFUL,
    UPDATE_NAME,
    UPDATE_USERNAME,
    UPDATE_EMAIL,
    UPDATE_PHONE,
    UPDATE_ADDRESS,
    UPDATE_BIO,
    CANCEL_PLAN
} from '../Actions/actionTypes';
import { cloneDeep } from 'lodash'

const initial = {
    results: {
        AppUser:{
            FirstName: '',
            UserId: localStorage.getItem('UserId'),
        },
        BusinessUser:{
            BusinessName:'',
            BusinessId: localStorage.getItem('BusinessId')
        }
    }
};
export default (state=initial,action) => {
    switch(action.type){
        case LOGIN:
            return action.payload;
        case LOGOUT:
            return initial;
        case GET_USER:
            return cloneDeep({
                ...state,
                results: action.payload.results
            });
        case UPDATE_VISIT:
            let st={...state};
            st.results.BusinessUser.IsFirstVisit=action.payload;
            return st;
        case REGISTER:
            return action.payload;
        case PAYMENT_SUCCESSFUL:
            state.results.IsActive = true;
            state.results.IsBillable = true;
            state.results.IsSubscribe = true;
            state.results.RedirectToOverview = true;
            return cloneDeep({...state});
        case UPDATE_NAME:
            state.results.AppUser.FirstName = action.payload;
            return cloneDeep({...state});
        case UPDATE_USERNAME:
            state.results.AppUser.UserName = action.payload;
            return cloneDeep({...state});
        case UPDATE_EMAIL:
            state.results.AppUser.Email = action.payload;
            return cloneDeep({...state});
        case UPDATE_PHONE:
            state.results.AppUser.PhoneNo = action.payload;
            return cloneDeep({...state});
        case UPDATE_ADDRESS:
            state.results.BusinessUser.PlaceID = action.payload.PlaceID;
            state.results.AppUser.FirstName = action.payload.BusinessName;
            state.results.BusinessUser.Address_Type = action.payload.Address_Type;
            state.results.BusinessUser.Address = action.payload.Address;
            state.results.BusinessUser.Address_Lat = action.payload.Address_Lat;
            state.results.BusinessUser.Address_Long = action.payload.Address_Long;
            return cloneDeep({...state});
      case UPDATE_BIO:
        state.results.AppUser.Bio = action.payload;
        return cloneDeep({...state});
      case CANCEL_PLAN:
          state.results.IsPlanCanceled= action.loginData.ResponseCode;



        return cloneDeep(state)
        default:
            return state;
    }
}